import { format } from "date-fns";

export const setExclusiveToDate = (toDate: string | null | undefined) => {
    // Have to do it manually or else it assumes the string is in UTC and translates to local (AKA, 1 day earlier)
    const s = toDate?.split(/\D/);
    if (!s || s?.length < 3) return undefined;
    const d = new Date(Number(s[0]), Number(s[1]) - 1, Number(s[2]));
    d.setDate(d.getDate() + 1);
    return format(d, "yyyy-MM-dd");
}